import $ from '@modules/jquery-import';
import {jqueryShowHint} from '@modules/lazy-imports';

$.fn.tooltip = async function () {
    await jqueryShowHint();

    var args = arguments,
        defaults = {
            show_triggers: 'mouseenter',
            hide_trigger: 'mouseleave mousedown',
            message: (typeof args[0] == 'string')
                ? args[0]
                : null,
            className: '',
            fx_speed: 100,
            placement: 'bottom',
            offset_top: null,
            touch_enabled: false
        },
        opt = $.extend( defaults, (typeof args[0] == 'object')
            ? args[0]
            : args[1] || {} );

    return $( this ).each( function () {
        var $node = $( this );

        $node.on( opt.show_triggers, '[data-tooltip]', function ( e ) {
            if ( e.target !== e.currentTarget ) {
                return;
            }
            // ignore tooltips for touch devices if disabled
            if ( !opt.touch_enabled && window.USER_IS_TOUCHING ) {
                return false;
            }

            e.preventDefault();

            if ( e.currentTarget.dataset['tooltip'] == null ) {
                e.currentTarget.dataset['tooltip'] = this.title;
            }
            $( e.currentTarget ).removeAttr( 'title' );
            $( this ).showHint( opt );
        } );
    } );
};
